import { Component, OnInit } from '@angular/core';
import { FieldType  } from '@ngx-formly/core';
import * as _ from 'lodash';
import * as constants from '../../types/constants';
import { FileUploaderOptions, FileLikeObject, FileUploader, FileItem } from 'ng2-file-upload';
import { ToasterService, ToasterConfig, BodyOutputType, Toast } from 'angular2-toaster/angular2-toaster';
import { WindowRefService } from '../../../shared/services/window-ref.service';
import { LOCALSTORAGE_AUTH } from '../../../../setup/configurations';

import { Ng2ImgMaxService } from 'ng2-img-max';
import { BlockUIService } from 'ng-block-ui';


@Component({
  selector: 'tr-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})


export class FileUploadComponent extends FieldType implements OnInit {

    private uploader: FileUploader;
    private mapFilterOption = {
        'fileSize': 'maxFileSize',
        'fileType': 'allowedFileType',
        'mimeType': 'allowedMimeType',
        'queueLimit': 0
    };

    uploadedImage: File;
    private oldFiles = [];
    private nativeWindow: any;
    private blockUI_target = 'stage-section';
    public showOverlay = false;

    private file_options;// local file options
    constructor(private toasterService: ToasterService, private windowRef: WindowRefService, private ng2ImgMax: Ng2ImgMaxService, private blockUI: BlockUIService) {
        super();
        this.nativeWindow = windowRef.getNativeWindow();
    }


    ngOnInit() {
        this.file_options = this.to.fileOptions;// pass "fileUploadConfigs" from formlyConfigs.ts

        // load existing files into the local variable from portal api from DB on init, this.to.fileInfo may have more than needed, also use this.oldFiles as it check against t42 id and answer
        this.oldFiles = _.has(this.to, 'fileInfo') ? _.filter(_.values(this.to.fileInfo), (info) =>
            _.indexOf((_.isArray(this.model[this.key]) ? this.model[this.key] : [this.model[this.key]]), info['id']) > -1) : [];


        //console.log(this.to.fileOptions);

        this.uploader = new FileUploader(
            Object.assign(_.omitBy(this.to.fileOptions, (value, optionName) => (_.isArray(value)) ? value.length === 0 : value === 0),
                !this.to.fileOptions['multiple'] ? { queueLimit: 1 } : {}
            )
        );

        //console.log(this.uploader);
        //console.log("fileinfo");
        //console.log(this.to.fileInfo);//

        //console.log("this.key");
        //console.log(this.key);
        //console.log('old files');
        //console.log(this.oldFiles);


        //console.log('queue init');
        //console.log(this.options['uploader'].queue);

        // reset queue for this.key, queue is share by all keys, each question has a key(t42 id)
        // find all instances
        var fileItems = _.filter(
            (<FileUploader>this.options['uploader']).queue,
            (fItem: FileItem) => fItem.additional['question'] === this.key);

        for (var i = 0; i < fileItems.length; i++)
        {
            //console.log("remove form item " + i);
            this.options['uploader'].removeFromQueue(fileItems[i]);

         }
        // reset queue for this.key


        //console.log('queue after reset');
        //console.log(this.options['uploader'].queue);

        // question type is file upload attachment, we need to add existing question answers (oldFiles) to global uploader queue
        if (this.oldFiles.length > 0)
        {
            //console.log("fileinfo");
            //console.log("before");
            //console.log(this.to.fileInfo);
            //console.log("old files");
            //console.log(this.oldFiles);

            for (var i = 0; i < this.oldFiles.length; i++)
            {
              const additional = {
                timeStamp: Math.round(+new Date() / 1000),
                question: this.key,
                fileid:this.oldFiles[i]['id'], // file id is used to mark existing files from DB,so it won't be uploaded again
                filesize:this.oldFiles[i]['size']// file.size is always 15 due to a bug in the lib, use size from oldFiles['size']
              };

              let tmp = this.options['sandbox'].getFileContent$(this.oldFiles[i]['id']);// get file contents by file ID

              let tmpFileExt = this.to.fileInfo[i]['name'].slice((this.oldFiles[i]['name'].lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase();
              let tmpFileType = this.getMimeType(tmpFileExt);

              // this.oldFiles[i]['type'] is always file from portal api, but don't use type for mime type when creating File
              let tmpFile = new File([tmp], this.oldFiles[i]['name'], { type: tmpFileType}); // initial a new File object for existing file
              // if type is wrong, the file upload will fail saying filename not supported in the network tab of the browser


              let tmpFileItem = new FileItem(this.options['uploader'], tmpFile, null, additional);
              // load to upload queue
              //this.uploader.addToQueue([tmpFile], null, null, additional);
              this.showOverlay = false;

              tmpFileItem.setAdditionalInfo(additional);

              // for existing old files, do not need to update modal[key] fileid to be filename[timestamp]

              // load into existing queue
              this.options['uploader'].addToQueue([tmpFileItem._file], null, null, additional);// add Existing File object to the uploader queue

              //console.log("load oldfiles into queue");
            }

        }
        // question type is file upload attachment, we need to add existing question answers (oldFiles) to global uploader queue

        //console.log('queue after');
        //console.log(this.options['uploader'].queue);


        this.uploader.onAfterAddingFile = (file: FileItem) => {
          this.showOverlay = true;

          const additional = {
              timeStamp: Math.round(+new Date() / 1000),
              question: this.key,
              oversized: false,
              uploaded:false // mark new file
          };

          //console.log(file.file);

          // maximum file siz 2MB, 2097152 Bytes (in binary) because file upload supports maximum 8MB but php ini supports upload_max_filesize 2MB
          // Ng2ImgMaxService file resize only supports image/png and image/jpeg

          // this.blockUI.start(this.blockUI_target,'optimising...');

          // php ini settings on service v2
          /*
           * upload_max_filesize 2MB
           * post_max_size 8MB
           */
          if (file.file.type == 'image/png' || file.file.type == 'image/jpeg')
          {
              // if png/jpeg size is more than 1 MB (1048576 Bytes) resize it
              if (file.file.size > 1048576)
              {
                // try resizing png/jpeg larger than 1MB
                this.blockUI.start(this.blockUI_target,'Please wait optimizing image...');
                this.showOverlay = false;
                console.log('max dimension reached');

                this.ng2ImgMax.resizeImage(file._file, 1600, 800).subscribe(
                  result => {
                    this.uploadedImage = new File([result], result.name, {
                      type: result.type,
                      lastModified: Date.now()
                    });

                    file._file = this.uploadedImage;
                    file.file.size = result.size;
                    file.file.type = result.type;

                    console.log('optimising for ' + file.file.type);
                    //console.log(result.size);
                    //console.log(result.type);

                    // const blob = new Blob([this.uploadedImage], { type: file.file.type });
                    // blob['lastModifiedDate'] = (new Date()).toISOString();
                    // blob['name'] = result.name;
                    //const testurl = window.URL.createObjectURL(blob);

                    additional['oversized'] = true;// mark for origin file size > 1MB

                    file.setAdditionalInfo(additional);

                    this.updateModel(file, 'add');
                    (<FileUploader>this.options['uploader']).addToQueue([this.uploadedImage], null, null, additional);
                    // (<FileUploader>this.options['uploader']).addToQueue([this.uploadedImage], null, null, additional);
                    // window.open(testurl);
                    this.showOverlay = false;
                    this.blockUI.stop(this.blockUI_target);
                  },
                  error => {
                    // display error on the toast
                    this.blockUI.stop(this.blockUI_target);
                    this.showOverlay = false;
                    console.log('Error ', error);

                    const toast = {
                      type: 'error',
                      title: 'File invalid',
                      body: `File: <b>${file.file.name}</b> is ignored<br>Constraint: <b>${error.error} </b><br> Reason: <b>${error.reason}</b>`,
                      bodyOutputType: BodyOutputType.TrustedHtml
                    };
                    this.toasterService.pop(toast);// render toast

                    // add file to the queue first, then remove it from the queue
                    file.setAdditionalInfo(additional);
                    this.updateModel(file, 'add');
                    (<FileUploader>this.options['uploader']).addToQueue([file._file], null, null, additional);
                    this.onItemRemove(file);
                    // add file to the queue first, then remove it from the queue

                  }
                );
              }
              else
              {
                console.log('Log: png/jpeg size less than 1MB');
                // all png/jpeg files less than 1MB, pass, do file upload now
                this.showOverlay = false;
                file.setAdditionalInfo(additional);

                this.updateModel(file, 'add');

                (<FileUploader>this.options['uploader']).addToQueue([file._file], null, null, additional);
              }
              // this.blockUI.stop(this.blockUI_target);
          }
          else
          {
            // http://byteconvert.org/
            // any generic files(NOT png/jpeg) larger than 2MB(2097152 Bytes) shall throw an error to the fron end, because file upload supports maximum 8MB but php ini supports upload_max_filesize 2MB
            if (file.file.size > 2097152)
            {

              this.showOverlay = false;
              console.log('Error ', 'maximum file size allowed is 2 MB(2097152 Bytes)');

              var file_size_in_bytes = this.niceBytes(file.file.size);

              const toast = {
                  type: 'error',
                  title: 'File is too large',
                  body: `File: <b>${file.file.name}</b> is ignored<br>Constraint: <b>file size</b><br> Reason: <b>maximum file size allowed is 2 MB, current file size ${file_size_in_bytes} </b>`,
                  bodyOutputType: BodyOutputType.TrustedHtml
              };
              this.toasterService.pop(toast);// render toast

              additional['oversized'] = true;// mark for origin file size > 1MB

              // add file to the queue first, then remove it from the queue
              file.setAdditionalInfo(additional);
              this.updateModel(file, 'add');
              (<FileUploader>this.options['uploader']).addToQueue([file._file], null, null, additional);
              this.onItemRemove(file);
              // add file to the queue first, then remove it from the queue

              //console.log((<FileUploader>this.options['uploader']));
            }
            else
            {
              console.log('Log: file size less than 2MB');
              // all files less than 2MB, pass, do file upload now
              this.showOverlay = false;
              file.setAdditionalInfo(additional);

              this.updateModel(file, 'add');// this is to mark newly updated file, to update model[key] = file_id to be model[key] = file_name[timestamp] so later once file uploaded in the stage.sandbox.ts, it will get fileid from response, and update model[key] = file_name[timestamp] back to model[key] = file id

              (<FileUploader>this.options['uploader']).addToQueue([file._file], null, null, additional);

              //console.log(this.options['uploader']);
              //console.log(this.options['uploader'].queue);
            }

          }

      };



        this.uploader.onWhenAddingFileFailed = (file, filters, options) => {
            let errorMessage;
            switch (filters.name) {
                case 'fileSize':
                    errorMessage = `File Size ${file.size} exceeded Maximum allowed file size ${this.file_options['maxFileSize']}`;
                break;
                case 'mimeType':
                    const allowedTypes = ['png','jpg','gif','txt','doc','docx','pdf','tiff','bmp'];
                    errorMessage = `Type ${file.type} is not allowed. Allowed types: ${allowedTypes}`;
                    break;
                case 'queueLimit':
                    errorMessage = `Maximum number of file allowed: 1`;
                    break;
                default:
                    errorMessage = `Unknown error (filter is ${filters.name})`;
            }
            const toast = {
                type: 'error',
                title: 'File invalid',
               // body: `File: <b>${file.name}</b> is ignored<br>Constraint: <b>${filters.name}= ${options[filters.name]}</b><br> Reason: <b>${errorMessage}</b>`,
                body: `File: <b>${file.name}</b> is ignored<br>Constraint: <b>${filters.name} </b><br> Reason: <b>${errorMessage}</b>`,
                bodyOutputType: BodyOutputType.TrustedHtml
            };
            this.toasterService.pop(toast);
        };

    }

    isIOS(): boolean {
        return this.nativeWindow.Modernizr.appleios;
    }

    getMimeType(ext) {

      // supported file mime type by file.inc
      var extToMimes = {
        "doc":"application/msword",
        "docx":"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "rtf":"application/rtf",
        "txt":"text/plain",
        "png":"image/png",
        "jpg":"image/jpeg",
        "jpeg":"image/jpeg",
        "gif":"image/gif",
        "tiff":"image/tiff",
        "bmp":"image/bmp",
        "pdf":"application/pdf",
        "xls":"application/vnd.ms-excel",
        "xlsx":"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "msg":"application/vnd.ms-outlook"
      }

      if (extToMimes.hasOwnProperty(ext)) {
          return extToMimes[ext];
      }
      else
      {
        return 'application/octet-stream';
      }

    };


    formatFileSize(size:number):string
    {
      if (size > 1048576 )
      {
        return (size / 1024 / 1024).toFixed(2) + ' MB';
      }
      else
      {
        return (size / 1024).toFixed(2) + ' KB';
      }
    }

    isFileItemType(fileItem)
    {
      return fileItem instanceof FileItem;
    }

    getQueueFiles() {
      // the function to load dynamic existing files into the UI from uploader queue
      let oldFiles2 = [];// array
      let tmpFileIDs = [];
      //console.log("debug global queue");
      //console.log(this.options['uploader'].queue);

      for (var j = 0; j < this.options['uploader'].queue.length; j++) {

        //console.log("question id " + this.options['uploader'].queue[j].additional.question + " key " + this.key + " file id " + this.options['uploader'].queue[j].additional.fileid);

        let tmp = {};// object
        let tmp2 = {};// object

        // for individual question
        if (this.options['uploader'].queue[j].additional.question == this.key) {

          // do not repeat adding the same file ID
          if (tmpFileIDs.indexOf(this.options['uploader'].queue[j].additional.fileid) == -1) {

            //console.log("new");
            if (this.options['uploader'].queue[j].additional.fileid > 0) {
              //console.log("existing fileid>0");
              tmp2['href'] = this.options['uploader'].queue[j].url;
              // replace /attachments with /fileid
              tmp2['href'] = tmp2['href'].replace("/attachments", "/" + this.options['uploader'].queue[j].additional.fileid);
              tmp['self'] = tmp2;

              // use additional.filesize instead of file.size as file.size is buggy from ng2-file-uploader lib
              oldFiles2[j] = { '_links': tmp, 'id': this.options['uploader'].queue[j].additional.fileid, 'type': this.options['uploader'].queue[j].file.type, 'size': this.options['uploader'].queue[j].additional.filesize, 'name': this.options['uploader'].queue[j].file.name };

              tmpFileIDs.push(this.options['uploader'].queue[j].additional.fileid);// push existing file with fileid from the uploader queue

            }
            else {
              //console.log("newly uploaded fileid<0");
              tmp2['href'] = this.options['uploader'].queue[j].url;
              tmp['self'] = tmp2;

              oldFiles2[j] = this.options['uploader'].queue[j];
            }

          }
          /* id, name, size, type:file, _links->self: url*/
        }

      }

      //console.log(tmpFileIDs);
      //console.log("oldFiles2 files ");
      //console.log(oldFiles2);
      // it may have dulplicates but not making trouble

      // remove blank elements in the array
      var filteredOldFiles2 = oldFiles2.filter(function (el) {
        return el != null;
      });

      //console.log("return queues filteredOldFiles2 files");
      //console.log(filteredOldFiles2);
      return filteredOldFiles2;


    }



    getFileUrl(file): string {
        return (this.getToken() !== '') ? `${file._links.self.href}?token=${this.getToken()}` : '#';
    }

    private getToken(): string {
        const item = window.localStorage.getItem(LOCALSTORAGE_AUTH);
        return (!item) ? '' : JSON.parse(item)['token'];
    }


    niceBytes(x){

      const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      let l = 0, n = parseInt(x, 10) || 0;

      while(n >= 1024 && ++l){
          n = n/1024;
      }
      //include a decimal point and a tenths-place digit if presenting
      //less than ten of KB or greater units
      return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
    }

    private updateValidation() {
        if (this.uploader.queue.length) {
            if (_.has(this.formControl.errors, 'required') && this.formControl.errors.required) {
                delete this.formControl.errors['required'];
                if (!_.size(this.formControl.errors)) {
                    this.formControl.setErrors(null);
                }
            }
        } else {
            const validators = this.formControl.validator ? this.formControl.validator(this.formControl) : {} ;
            if (_.has(validators, 'required') && validators.required) {
                this.formControl.setErrors({ required: true });
            }
        }
    }

    private updateModel(fileItem: FileItem, action: string) {

        this.formControl.markAsDirty();
        // for newly uploaded file, this is to update the modal[t42_id] = file_id to be modal[t42_id] = file_name[timestamp]
        // for existing files from db, do NOT call updateModel() function
        const fileName = `${fileItem.file.name}[${fileItem.additional.timeStamp}]`;
        const clone = _.cloneDeep(this.model[this.key] || []);
        if (action === 'add') {
           this.model[this.key] = this.to.fileOptions.multiple ? _.concat(clone, fileName) : fileName;
        } else if (action === 'remove') {
            this.model[this.key] = this.to.fileOptions.multiple ? _.pull(clone, fileName) : null;
        }
        
        this.formControl.setValue(this.model[this.key]); //Siddharth ADO-124598 & ADO-125169 Bug Fix for File validation
        this.updateValidation();
    }


    // called in L10 of file-upload.component.html
    getLabelText(): string {
        /* debug
        console.log('local');
        for (var i = 0; i < this.uploader.queue.length; i++) {
          var key = this.uploader.queue[i].additional['question'];
          console.log(key);
        }
        console.log('global');
        for (var i = 0; i < this.options['uploader'].queue.length; i++) {
          var key = this.options['uploader'].queue[i].additional['question'];
          console.log(key);
        }
        */

        if (this.options['uploader'].queue.length == 0 && this.uploader.queue.length > 0)
        {
          // this.uploader is local question uploader
          // this.options['uploader'] is global uploader
          this.uploader.clearQueue(); // clear individual uploader queue if global uploader queue is 0 triggered by removeAllOldFiles()
        }

        var keys = [];// global queue question IDs
        for (var j = 0; j < this.options['uploader'].queue.length; j++)
        {
          var fItemKey = this.options['uploader'].queue[j].additional['question'];
          keys.push(fItemKey);
        }

        for (var i = 0; i < this.uploader.queue.length; i++)
        {
          // to find question/key from local queue that does not exist in the global queue, and remove it from local queue
          var key = this.uploader.queue[i].additional['question'];

          //console.log('local key ' + key);
          var fileItems = _.filter(
            this.uploader.queue,
            (fItem: FileItem) => !keys.includes(fItem.additional['question']) && fItem.additional['oversized'] == false);// exclude oversized 1M images

          //console.log(fileItems);

          for (var j = 0; j < fileItems.length; j++) {
            //console.log('found local key not in global queue, remove from local queue ');
            //console.log(fileItems[j]);
            this.uploader.removeFromQueue(fileItems[j]);
          }

        }

        // debug
        //return `local ${this.uploader.queue.length} ` + ` global ${this.options['uploader'].queue.length} `;


        if (this.uploader.queue.length == 0) {
            return 'Choose file' + (this.to.fileOptions['multiple'] ? 's' : '');
        } else {
            return `${this.uploader.queue.length}  file` + (this.uploader.queue.length > 1 ? 's' : '') + ' selected';
        }


    }

    onItemRemove(item: FileItem) {
        this.uploader.removeFromQueue(item);
        this.updateModel(item, 'remove');
       (<FileUploader>this.options['uploader']).removeFromQueue(_.find((<FileUploader>this.options['uploader']).queue, (fItem: FileItem) => fItem._file === item._file));
    }

    decodeString(st: string): string {
        return decodeURI(st);
    }

    onViewFile(file) {
      event.preventDefault();
        const payload = {
            questionId: this.key,
            name: file.name,
            link: file._links.self.href,
            authRequired: true,
            action: 'download'
        };

        this.options['sandbox'].dispatchDownload(payload);
    }

    onRemoveOldFile(file) {
      const clone = _.cloneDeep(this.model[this.key] || []);

      this.formControl.markAsDirty();
      this.model[this.key] = _.cloneDeep(this.to.fileOptions.multiple ? _.pull(clone, file.id) : null);
      this.oldFiles = _.reject(this.oldFiles, (f) => f.id === file.id);

      let fileItem = _.find(
      (<FileUploader>this.options['uploader']).queue,
      (fItem: FileItem) => fItem.additional['fileid'] !== undefined && fItem.additional['fileid'] === file.id);

      this.uploader.removeFromQueue(fileItem);
      this.updateModel(fileItem, 'remove');
      (<FileUploader>this.options['uploader']).removeFromQueue(fileItem);

      this.formControl.setValue(this.model[this.key]);
      this.updateValidation();
    }

    // remove all attachments against this.key which is t42 ID
    // this function is called when the response option of the parental question is changed, reset child questions answers
    removeAllOldFiles(field, options) {
      var key = field.key;// key is t42 id

      /*
      if (_.has(field.formControl.errors, 'required') && field.formControl.errors.required) {
        delete field.formControl.errors['required'];
        if (!_.size(field.formControl.errors)) {
          field.formControl.setErrors(null);
        }
      }
      */

      //options['uploader'].clearQueue();// don't use clear queue function  to clear the global queue

      // find all instances of global uploader
      var fileItems = _.filter(
        (<FileUploader>options['uploader']).queue,
        (fItem: FileItem) => fItem.additional['question'] === key);

      // remove from global queue
      for (var i = 0; i < fileItems.length; i++)
      {
        options['uploader'].removeFromQueue(fileItems[i]); // remove file item from the global queue
      }

      //console.log("queue: ");
      //console.log(options['uploader']);

    }

    truncateFileName (fileName: string): string {
      let truncatedFileName = fileName;
      if (fileName.length > 30) {
        truncatedFileName = fileName.substring(0,20) +"..."+ fileName.substring(fileName.length - 7);
      }
      
      return truncatedFileName;
    }
}



// WEBPACK FOOTER //
// ./src/app/stage/components/file-upload/file-upload.component.ts